import { useGlobalState } from '@/hooks';
import { ISSUE_CONFIG, TRACKING_MILESTONE_TRANSLATION } from '@/modules/pmt/constants';
import type { IProgressStage, TrackingMilestone } from '@/modules/pmt/interfaces';
import Image from 'next/image';
import { Chip, ChipText } from './ShipmentCardChip.styles';

interface ShipmentCardChipProps {
  hasIssue: boolean;
  milestone: TrackingMilestone;
  stage: IProgressStage;
}

const ShipmentCardChip = ({ hasIssue, milestone, stage }: ShipmentCardChipProps) => {
  const { t } = useGlobalState();
  const translatedMileStone = t(TRACKING_MILESTONE_TRANSLATION[milestone]);
  const milestoneAlt = hasIssue ? 'Issue icon' : translatedMileStone;
  const milestoneIcon = hasIssue ? ISSUE_CONFIG.iconSrc : stage.iconSrc;
  const milestoneColor = hasIssue ? ISSUE_CONFIG.colorScheme : stage.colorScheme;

  return (
    <Chip colorScheme={milestoneColor}>
      <Image src={milestoneIcon} alt={milestoneAlt} width={20} height={20} aria-hidden={true} />
      <ChipText>{translatedMileStone}</ChipText>
    </Chip>
  );
};

export { ShipmentCardChip };
